import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
var getCookie = function(key) {
    if ("object" === "undefined") {
        return "";
    }
    return document.cookie.split("; ").reduce(function(total, currentCookie) {
        var ref = _sliced_to_array(currentCookie.split("="), 2), storedKey = ref[0], storedValue = ref[1];
        return key === storedKey ? decodeURIComponent(storedValue) : total;
    }, "");
};
export default getCookie;
